import { Alert, Snackbar } from "@mui/material";
import { observer } from "mobx-react";
import { useStoreContext } from "../index";
import { useTranslation } from "react-i18next";
import DataStore from "../store/DataStore";
import { SyntheticEvent } from "react";

interface SaveStatus {
  store: DataStore;
  successId: string;
  successMessage: string;
  errorId: string;
  errorMessage: string;
}

const StatusSnackBar = observer(() => {
  const {
    formStore,
    measurementStore,
    treatmentStore,
    drugStore,
    fieldStore,
    indicationStore,
  } = useStoreContext();
  const { t } = useTranslation();

  const errors = [
    formStore,
    measurementStore,
    treatmentStore,
    drugStore,
    fieldStore,
    indicationStore,
  ].flatMap((store) =>
    Array.from(store.error).map((error): any => {
      return {
        store: store,
        errorId: error,
        errorMessage: t("errors." + error),
      };
    })
  );

  const successes = [
    formStore,
    measurementStore,
    treatmentStore,
    drugStore,
    fieldStore,
    indicationStore,
  ].flatMap((store) =>
    Array.from(store.success).map((success): any => {
      return {
        store: store,
        successId: success,
        successMessage: t("success." + success),
      };
    })
  );

  const handleErrorClose = (
    event: Event | SyntheticEvent<any, Event>,
    status: SaveStatus
  ) => {
    if (event instanceof PointerEvent) {
      return;
    }
    status.store.clearError(status.errorId);
  };

  const handleSuccessClose = (
    event: Event | SyntheticEvent<any, Event>,
    status: SaveStatus
  ) => {
    if (event instanceof PointerEvent) {
      return;
    }

    status.store.clearSuccess(status.successId);
  };

  return (
    <>
      {errors.map((error) => (
        <Snackbar
          key={error.store.constructor.name + "-" + error.errorId}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          open={error.store.error.has(error.errorId)}
          onClose={(e) => handleErrorClose(e, error)}
        >
          <Alert
            onClose={(e) => handleErrorClose(e, error)}
            severity="error"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {error.errorMessage}
          </Alert>
        </Snackbar>
      ))}
      {successes.map((success) => (
        <Snackbar
          key={success.store.constructor.name + "-" + success.successId}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          autoHideDuration={5000}
          open={success.store.success.has(success.successId)}
          onClose={(e) => handleSuccessClose(e, success)}
        >
          <Alert
            onClose={(e) => handleSuccessClose(e, success)}
            severity="success"
            variant="filled"
            sx={{ width: "100%" }}
          >
            {success.successMessage}
          </Alert>
        </Snackbar>
      ))}
    </>
  );
});

export default StatusSnackBar;
